import apiFetch from '../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `Dossier/Sales/${dossierId}/SkipItv`, method: 'PUT', body: null, token: token })
}
